var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-ing"},[_c('div',{staticClass:"live-ing-txt"},[_vm._v("主播暂未开播")])])}]

export { render, staticRenderFns }